import type { Coords, Dims, MaskOptions } from 'walktour'

// replace any newline to space and remove extra spaces
const trimAndJoin = (str: TemplateStringsArray, ...args: any[]): string => {
  const temp = str.reduce((acc, curr, i) => acc + args[i - 1] + curr)

  return temp.replace(/\s+/g, ' ').trim()
}

const getCutoutPath = ({
  target,
  containerWidth,
  containerHeight,
  padding,
  radius,
}: {
  target?: { coords: Coords; dims: Dims }
  containerWidth: number
  containerHeight: number
  padding: number
  radius: number
}): string => {
  if (!target) {
    return ''
  }

  const { dims, coords } = target

  const cutoutTop: number = coords.y - padding
  const cutoutLeft: number = coords.x - padding
  const cutoutRight: number = coords.x + dims.width + padding
  const cutoutBottom: number = coords.y + dims.height + padding

  if (radius > 0) {
    return trimAndJoin`M 0, 0
            L 0, ${containerHeight}
            L ${cutoutLeft}, ${containerHeight}
            L ${cutoutLeft}, ${cutoutTop + radius}
            Q ${cutoutLeft}, ${cutoutTop}, ${cutoutLeft + radius}, ${cutoutTop}
            L ${cutoutRight - radius}, ${cutoutTop}
            Q ${cutoutRight}, ${cutoutTop}, ${cutoutRight}, ${
      cutoutTop + radius
    }
            L ${cutoutRight}, ${cutoutBottom - radius}
            Q ${cutoutRight}, ${cutoutBottom}, ${
      cutoutRight - radius
    }, ${cutoutBottom}
            L ${cutoutLeft + radius}, ${cutoutBottom}
            Q ${cutoutLeft}, ${cutoutBottom}, ${cutoutLeft}, ${
      cutoutBottom - radius
    }
            L ${cutoutLeft}, ${containerHeight}
            L ${containerWidth}, ${containerHeight}
            L ${containerWidth}, 0`
  }

  return trimAndJoin`M 0, 0
          L 0, ${containerHeight}
          L ${cutoutLeft}, ${containerHeight}
          L ${cutoutLeft}, ${cutoutTop}
          L ${cutoutRight}, ${cutoutTop}
          L ${cutoutRight}, ${cutoutBottom}
          L ${cutoutLeft}, ${cutoutBottom}
          L ${cutoutLeft}, ${containerHeight}
          L ${containerWidth}, ${containerHeight}
          L ${containerWidth}, 0`
}

/**
 * Based on Mask component from Walktour,
 * but the cutout path is generated using CSS clip-path instead of SVG.
 */
export function Mask(props: MaskOptions) {
  const {
    targetInfo,
    disableMaskInteraction,
    padding,
    radius,
    tourRoot,
    close,
    disableCloseOnClick,
  } = props
  const containerWidth = tourRoot.clientWidth
  const containerHeight = tourRoot.clientHeight

  return (
    <div
      onClick={disableCloseOnClick ? undefined : close}
      className="bg-black/70"
      style={{
        pointerEvents: disableMaskInteraction ? 'auto' : 'none',
        width: `${containerWidth}px`,
        height: `${containerHeight}px`,
        clipPath: targetInfo
          ? `path("${getCutoutPath({
              target: targetInfo,
              containerWidth,
              containerHeight,
              padding,
              radius,
            })}")`
          : undefined,
      }}
    ></div>
  )
}
